/**
 *
 * Load Plugins
 * If you don't see a plugin below it might be autloaded via webpack
 * Check webpack.mix.js for autoloaded plugins.
 *
 */
require('@fancyapps/fancybox');
require('unveil2');

const VimeoPlayer = require('@vimeo/player');

// window.Headroom = require('headroom.js');
// import 'headroom.js/dist/jQuery.headroom'

import { Foundation } from './foundation';
import { WOW } from 'wowjs';
Foundation.addToJquery(jQuery);


/**
 *
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 *
 */
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
let token = document.head.querySelector('meta[name="csrf-token"]');
if (token) {
    window.axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content;
} else {
    console.error('CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token');
}

/**
 *
 * Application script
 *
 */
$(function() {
    $(document).foundation();

    //firing lazyloader
    // $('.unveil-img').unveil();

    // Image tile accordions
    // $('.image-tile--accordion').off('click');

    if (!Foundation.MediaQuery.atLeast('large')) {
        $('.image-tile__title').on('click', function(e) {
            e.preventDefault();
            let item = $(this).parent('.image-tile--accordion');
            $(item).toggleClass('is-active');
            $(item).find('.image-tile__content').slideToggle();
        });
    }

    if (!Foundation.MediaQuery.atLeast('large')) {
        $('.icon-tile__title').on('click', function(e) {
            e.preventDefault();
            let item = $(this).parent('.icon-tile--accordion');
            $(item).toggleClass('is-active');
            $(item).find('.icon-tile__content').slideToggle();
        });
    }

    // Load Google map javascript
    if(document.querySelector('[data-maps-api-key]') && !document.querySelector('.gMapsAPI')){
        if($('[data-maps-api-key]').length){
            let script = document.createElement('script');
            const apiKey = $('[data-maps-api-key]:first').attr('data-maps-api-key');
            script.type = 'text/javascript';
            script.src = 'https://maps.googleapis.com/maps/api/js?key=' + apiKey + '&callback=initializeMaps';
            script.className = 'gMapsAPI';
            document.body.appendChild(script);
        }
    }

    // Banner Slideshow
    if($('.banner--slick').length > 0) {
        $('.banner--slick').slick({
            autoplay: true,
            autoplaySpeed: 5000,
            speed: 800,
            infinite: true,
            slidesToShow: 1,
            arrows: true,
            prevArrow: '<span class="ui-arrow ui-arrow--prev"></span>',
            nextArrow: '<span class="ui-arrow ui-arrow--next"></span>',
            fade: true,
        });
    }

    // Gallery Slideshow
    if($('.gallery-slideshow__inner').length > 0) {
      $('.gallery-slideshow__inner').slick({
            infinite: true,
            dots: true,
            slidesToShow: 1,
            arrows: true,
            prevArrow: '<span class="ui-arrow ui-arrow--prev"></span>',
            nextArrow: '<span class="ui-arrow ui-arrow--next"></span>',
            speed: 800
        });
    };

    // Wowjs
    var wow = new WOW(
        {
            boxClass:     'wow',            // animated element css class (default is wow)
            animateClass: 'is-animating',   // animation css class (default is animated)
            offset:       0,                // distance to the element when triggering the animation (default is 0)
            mobile:       true,             // trigger animations on mobile devices (default is true)
            live:         true,             // act on asynchronously loaded content (default is true)
            callback:     function(box) {
            // the callback is fired every time an animation is started
            // the argument that is passed in is the DOM node being animated
            },
            scrollContainer: null // optional scroll container selector, otherwise use window
        }
    );

    wow.init();

    // Match height
    $('.mh').matchHeight({
        byRow: true
    });

    $.fn.ScrollToElement = function(speed = 2000,customoffset = 0){
        var page = $("html, body"),
            stopEvents = 'scroll mousedown wheel DOMMouseScroll mousewheel keyup touchmove';
        page.on(stopEvents, function(){
            page.stop();
        });
        page.animate({ scrollTop: $(this).offset().top + customoffset }, speed, function(){
           page.off(stopEvents);
        });
    };
    if($('.banner-anchor').length > 0){
      $('.banner-anchor').click(function(event){
          if ($(this).attr('href')) {
              event.preventDefault();
              var url = $(this).attr('href'), idx = url.indexOf("#")
              var hash = idx != -1 ? '#' + url.substring(idx+1) : "#";
              $(hash).ScrollToElement(2000, 0);
          }
      });
    }
    if($('.home-enquire-link').length > 0){
      $('.home-enquire-link').click(function(event){
          if ($(this).attr('href')) {
              event.preventDefault();
              var selection = $(this).data('select');
              var url = $(this).attr('href'), idx = url.indexOf("#");
              var hash = idx != -1 ? '#' + url.substring(idx+1) : "#";
              $('#Form_InterestRegistrationForm .dropdown').val(selection);
              $(hash).ScrollToElement(2000, -100);
          }
      });
    }
    //toggle active state on hamburger menu icon
    $('.header .hamburger').click(function(){
        $(this).toggleClass('is-active');
    });

    if($("#Form_InterestRegistrationForm").length > 0){
        var form = $('#Form_InterestRegistrationForm');
        $("#Form_InterestRegistrationForm").submit(function(e){
            e.preventDefault();
            e.stopImmediatePropagation();
            var formData = $(this).serialize();
            $.ajax({
                type: 'POST',
                url: $(form).attr('action'),
                dataType: 'jsonp',
                data: formData,
                complete: function( response ){
                    var response = jQuery.parseJSON(response.responseText);
                    if (response.Message !== '' && response.Success == true) {
                        $(".form-wrap").animate({'opacity' : 0}, 500, function(){
                            $(this).html(response.Message).animate({'opacity' : 1}, 500);
                        });
                    } else {
                        $(".form-wrap").prepend('<p class="message bad">There was an error processing your enquiry, please try again later.</p>');
                    }
                }
            });

            return false;
        });
      }

      //load video section Video
      if($('.section-video-link').length > 0){
        $('.section-video-link').click(function(e){
            e.stopPropagation();
            e.preventDefault();
            var url = $(this).attr('href'),
              container = $(this);
            // Return the video code
            $.post(url, function(data){
                container.animate({'opacity' : 0}, 500, function(){
                    $(this).replaceWith(data);
                    if($(this).hasClass('tile-video')){
                        $(this).children('.videoWrapper').addClass('tile-videoWrapper');
                    }
                    $(this).animate({'opacity' : 1}, 500);
                });
            });
        });
      }


      if($('.map').length > 0){
       $('.map').each(function(i, obj) {
           var element = $("#"+$(this).attr('id'));
           var zoom = element.data('zoom');
           var lat = element.data('lat');
           var long = element.data('long');
           initializeMap(document.getElementById($(this).attr('id')), zoom, lat, long);
           google.maps.event.trigger(element, "resize");
       });
      }
      function initializeMap(element, zoom, lat, long) {
          var mapOptions = {
              zoom : zoom,
              scrollwheel : false,
              draggable: false,
              center : new google.maps.LatLng(lat, long)
          };
          var map = new google.maps.Map(element, mapOptions);
          var marker = new google.maps.Marker({
              position: new google.maps.LatLng(lat, long),
              map: map
          });
      }

      //userform field placeholders
      // Compact fields
       const activeclass = 'active-focus',
           hasvalueclass = 'has-value',
           novalueclass = 'no-value'
       $('.field:not(.CompositeField):not(.dropdown)').each(function() {
           let field = this
           $(this).find('input, textarea, select').focus(function(){
               $(field).addClass(activeclass).removeClass(novalueclass).removeClass(hasvalueclass)
           }).blur(function(){
               $(field).removeClass(activeclass)
               if ($(this).val()) {
                   $(field).addClass(hasvalueclass).removeClass(novalueclass)
               } else {
                   $(field).removeClass(hasvalueclass).addClass(novalueclass)
               }
           }).blur()
    });

    //unveil image lazyloading effect
    if($('.unveil-img').length > 0){
        $('.unveil-img').unveil({
        }).on('loaded.unveil', function(){
            $(this).css({
                'opacity' : 1
            });
        });
      }

});



// WEBPACK FOOTER //
// ./themes/base/js/app.js